<template>
  <div>
    <div class="lightestGreyBackground external-calc-height">
      <div class="form-wrap">
        <StartWorkflowManager
          v-if="showFormUI"
          :viewMode="true"
          @workflowStarted="showSnack(true)"
          @workflowFailed="showSnack(false)"
        />
        <div v-if="!isLoading && !showFormUI" id="forbidden-container">
          <VasionRemoveCircleIcon id="no-entry-icon" />
          <div id="message">
            You are not authorized to access this form.
          </div>
        </div>
      </div>
      <VasionSnackbar
        id="results-snack"
        :showSnackbarBool.sync="showSnackbar"
        :snackbarImage="snackbarImage"
        :snackbarTitle="snackbarTitle"
      />
    </div>
  </div>
</template>

<script>
import StartWorkflowManager from '@/components/workflow/StartWorkflowManager.vue'

export default {
  name: 'PlainForm',
  components: {
    StartWorkflowManager,
  },
  data: function () {
    return {
      isAuthed: false,
      isLoading: true,
      publicAccessible: false,
      showSnackbar: false,
      snackbarImage: false,
      snackbarTitle: '',
    }
  },
  computed: {
    eForm() { return this.$store.state.forms.eForm },
    showFormUI() { return this.isAuthed || this.publicAccessible },
  },
  watch: {
    eForm: {
      handler() {
        if (this.$store.state.forms.eForm && this.$store.state.forms.eForm.PublicAccessible) {
          this.publicAccessible = true
        } else if (this.$store.state.forms.eForm && !this.$store.state.forms.eForm.PublicAccessible) {
          this.$router.push({ name: 'TheLogin', query: { redirect: `/form/${this.$route.params.formName}/${this.$route.params.formID}` } })
        }
      },
      deep: true,
    },
  },
  async created() {
    if (this.$route.params.formID === 0) {
      this.publicAccessible = false
      this.isAuthed = false
      return
    }
    await this.$store.dispatch('forms/getEForm', this.$route.params.formID)
    if (!this.$store.state.forms.eForm?.PublicAccessible && !this.$store.state.common.isSignedIn) {
      this.$router.push({ name: 'TheLogin', query: { redirect: `/formLink/${this.$route.params.formName}/${this.$route.params.formID}` } })
    } else if (this.$store.state.forms.eForm?.PublicAccessible) {
      this.publicAccessible = true
    } else {
      this.isAuthed = await this.$store.dispatch('forms/checkIfUserCanAccessEForm', this.$route.params.formID)
    }
    this.isLoading = false
  },
  methods: {
    showSnack(val) {
      this.snackbarTitle = val ? `${$layoutsLabel} Submitted!` : `${$layoutsLabel} Submission Failed!`
      this.snackbarImage = val
      this.showSnackbar = true
    },
  },
}
</script>

<style lang="scss" scoped>
  @import '@/assets/css/variables.scss';
  .external-calc-height {
    height: 100vh;
    width: 100vw;
  }
  #forbidden-container {
    height: calc(100vh - 160px);
    margin-top: 16px;
    display: flex;
    align-items: center;
    justify-content: center;
    flex-direction: column;
    #message {
      font-family: $font-family-bold;
      margin-top: 20px;
      position: relative;
      font-size: 30px;
      bottom: 10%;
    }
    #no-entry-icon {
      fill: $grey-600;
      position: relative;
      bottom: 10%;
    }
  }
  .lightestGreyBackground {
    background-color: $grey-75;
    display: flex;
    flex-direction: column;
    align-items: center;
  }
  .form-wrap {
    margin-top: 32px;
    width: 1104px;
    height: calc(100vh - 74px);
    border-radius: 8px;
    box-shadow: 0 1px 2px 0 rgba(0, 0, 0, 0.11), 0 4px 8px 0 rgba(0, 0, 0, 0.13);
    background-color: $white;
  }
  @media (min-width: 10px) {
    .form-wrap {
      width: 90%;
    }
  }
  @media (min-width: 900px) {
    .form-wrap {
      width: 692px;
    }
  }
  @media (min-width: 1200px) {
    .form-wrap {
      width: 900px;
    }
  }
</style>
